import { Check, ArrowUpRight } from "lucide-react";
import { FadeUp } from "../Reveal";
import { waLink } from "../../data/site";
import { track } from "../../lib/analytics";

const CHECKLIST = [
    "Materiais gráficos",
    "Comunicação visual",
    "Uniformes",
    "Placas e sinalização",
    "Adesivos",
    "Materiais promocionais",
    "Personalização",
];

export const B2B = () => (
    <section id="empresas" data-testid="b2b-section" className="grain relative overflow-hidden bg-ink py-20 sm:py-28 lg:py-32 text-white">
        <div className="absolute -bottom-48 -right-48 h-[520px] w-[520px] rounded-full bg-brand/10 blur-[150px]" />
        <div className="container-x relative grid items-center gap-14 lg:grid-cols-2">
            <div>
                <FadeUp>
                    <p className="section-tag flex items-center gap-3">
                        <span className="inline-block h-px w-8 bg-brand" />
                        02 — Para empresas
                    </p>
                </FadeUp>
                <FadeUp delay={0.08}>
                    <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.06]">
                        Sua empresa precisa de material.{" "}
                        <span className="text-brand">Nós cuidamos da produção.</span>
                    </h2>
                </FadeUp>
                <FadeUp delay={0.16}>
                    <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-mist">
                        Do primeiro cartão de visita à comunicação visual completa, a IMPRIMA AKI ajuda empresas e
                        profissionais a manterem sua marca presente em todos os pontos de contato com o cliente.
                    </p>
                </FadeUp>
                <FadeUp delay={0.24}>
                    <ul className="mt-9 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
                        {CHECKLIST.map((item) => (
                            <li key={item} className="flex items-center gap-3 text-sm sm:text-base font-medium text-white/90">
                                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand/15 text-brand">
                                    <Check size={13} strokeWidth={3} />
                                </span>
                                {item}
                            </li>
                        ))}
                    </ul>
                </FadeUp>
                <FadeUp delay={0.32}>
                    <a
                        href={waLink("Olá! Quero cotar materiais para minha empresa. Vim pelo site da Imprima Aki.")}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => track("whatsapp_click", { location: "b2b_section" })}
                        data-testid="b2b-cta"
                        className="group mt-10 inline-flex items-center gap-3 rounded-full bg-white px-8 py-4 text-sm font-bold uppercase tracking-wider text-ink transition-all duration-300 hover:bg-brand hover:text-white"
                    >
                        Quero cotar para minha empresa
                        <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </a>
                </FadeUp>
            </div>

            <FadeUp delay={0.15} className="relative">
                <div className="relative overflow-hidden rounded-2xl border border-line">
                    <img
                        src="/images/b2b.jpg"
                        alt="Materiais impressos e amostras de comunicação visual para empresas"
                        data-testid="b2b-image"
                        loading="lazy"
                        className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
                </div>
                <div className="absolute -bottom-5 -left-3 sm:-left-6 rounded-xl border border-line bg-coal px-5 py-4 shadow-2xl">
                    <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand">Atendimento B2B</p>
                    <p className="mt-1 text-sm font-semibold text-white/90">Empresas, comércios e profissionais</p>
                </div>
            </FadeUp>
        </div>
    </section>
);
